import React, { useEffect, useRef, useState } from 'react';
import { toast } from 'react-toastify';
import { Link } from "react-router-dom";
import { Button, Badge } from "react-bootstrap";
import { Tooltip, OverlayTrigger } from "react-bootstrap";
import swal from "sweetalert2";
import $ from 'jquery';
import 'datatables.net';
import 'datatables.net-dt/css/dataTables.dataTables.css';
import LightGallery from 'lightgallery/react';
import 'lightgallery/css/lightgallery.css';
import 'lightgallery/css/lg-zoom.css';
// import 'lightgallery/css/lg-thumbnail.css';
import lgThumbnail from 'lightgallery/plugins/thumbnail';
import lgZoom from 'lightgallery/plugins/zoom';
import axios from 'axios'; // new
import { Row, Col, Tab, Nav, Dropdown } from "react-bootstrap";
import default_img from '../../../../../images/product/productcategory.png';
import Add from '../../../../modal/Settings/Package_Management/Product_Category/AddProdCat';
import Edit from '../../../../modal/Settings/Package_Management/Product_Category/EditProdcat';
import EditProdcat from '../../../../modal/Settings/Package_Management/Product_Category/EditProdcat';
import ViewProdCat from '../../../../modal/Package_Management/Manage_Product/ProductCategory.js/ViewProdCat';
import AddProduct from '../../../../modal/Package_Management/Manage_Product/ProductCategory.js/CreateProduct';

const ProductCategory = () => {
  const [key, setKey] = useState('product_category');
  const baseURL = process.env.REACT_APP_API_BASE_URL;
  const tableRef = useRef(null);
  const onInit = () => {
    //   console.log('lightGallery has been initialized'); 
  };
  const [open, setOpen] = useState(false); // Modal visibility state
  const [modalType, setModalType] = useState("");
  const [editModalShow, setEditModalShow] = useState(false);
  const [currentItemId, setCurrentDepartmentId] = useState(null);

  const handleModalToggle = () => {
    setModalType("Add");  // Set the modal type to "Add"
    setOpen(true);  // Toggle the modal visibility
  };
  const handleModalToggle_Edit = () => {
    setModalType("Edit");  // Set the modal type to "Add" 
    setOpen(true);
  };
  const [page, setPage] = useState(1); //pagination
  const [totalPages, setTotalPages] = useState(1); //pagination
  const [searchTerm, setSearchTerm] = useState(''); //pagination
  const [perPage, setPerPage] = useState(10); //pagination
  const [productCategories, setProductCategories] = useState([]); //new list
  const [categoryCount, setCategoryCount] = useState(0); //count
  const [manageProductCount, setManageProductCount] = useState(0);  // product count
  const [hasFetched, setHasFetched] = useState(false);

  const softRefresh = () => {
    setHasFetched(false);
    if ($.fn.dataTable.isDataTable(tableRef.current)) {
      $(tableRef.current).DataTable().destroy();
    }
    fetchCategories();
  }

  const branch_id = parseInt(localStorage.getItem("branch_id"), 10);

  const fetchCategories = async (pageNumber = 1, perPageCount = 25, search = '') => {
    try {
      const params = {
        page: pageNumber,
        per_page: perPageCount,
        search: search,
      };

      if (branch_id) {
        params.branch_id = branch_id;
      }

      const response = await axios.get(`${baseURL}/product-categories`, { params });

      const data = response.data;
      const categoryList = Array.isArray(data.data) ? data.data : [];

      setProductCategories(categoryList);
      setCategoryCount(data.ProductCategoryCount || categoryList.length);
      setHasFetched(true);

    } catch (error) {
      console.error('Error fetching categories:', error);
      setProductCategories([]);
    }
  };

  // This useEffect runs whenever page, perPage, or searchTerm changes.
  useEffect(() => {
    fetchCategories(page, perPage, searchTerm);
  }, [page, perPage, searchTerm]);


  useEffect(() => {
    fetchCategories(page, perPage, searchTerm);
  }, [page, searchTerm, perPage]);

  useEffect(() => {
    axios.get(`${baseURL}/manage-products?branch_id=${branch_id}`)
      .then(response => {
        const data = response.data;
        if (data?.ManageProductCount) {
          setManageProductCount(data.ManageProductCount);  // Set the count value
        } else {
          console.warn("Unexpected response format:", data);
          setManageProductCount(0);  // Default if count is not found
        }
      })
      .catch(error => {
        console.error("Error fetching manage products count:", error);
        setManageProductCount(0);  // Default if error occurs
      });
  }, []);

  const handleModalDepartment_Edit = (id) => {
    setEditModalShow(true);
    setCurrentDepartmentId(id);
  };

  const DeleteModal = (id, name, fetchCategories) => {
    swal.fire({
      html: `
                <div class="alert alert-danger px-2 py-2" role="alert">
                    <strong>OOPS! </strong> You're about to lose one Products
                    <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
                </div>
                <p class="text-center"><b>${name}</b></p>  
                <div class="text-center">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" width="48" height="48">
                        <defs>
                            <radialGradient id="radial-gradient" cx="-27.957" cy="8.563" r="6" gradientTransform="matrix(3 0 0 2.5 107.871 -4.408)" gradientUnits="userSpaceOnUse">
                                <stop offset="0" stop-color="#5987dd"/>
                                <stop offset=".118" stop-color="#638bd6"/>
                                <stop offset=".316" stop-color="#7d98c3"/>
                                <stop offset=".572" stop-color="#a8aba3"/>
                                <stop offset=".871" stop-color="#e3c678"/>
                                <stop offset="1" stop-color="#ffd364"/>
                            </radialGradient>
                            <style>.cls-3{fill:#ffb32b}.cls-4{fill:#273941}.cls-5{fill:#141e21}.cls-6{fill:#f6fafd}</style>
                        </defs>
                        <g id="_27-feel_bad" data-name="27-feel bad">
                            <circle cx="24" cy="24" r="23" style="fill:#ffce52"/>
                            <ellipse cx="24" cy="17" rx="18" ry="15" style="fill:url(#radial-gradient)"/>
                            <path class="cls-3" d="M46 23c0 10.493-9.85 19-22 19S2 33.493 2 23h-.975c-.014.332-.025.665-.025 1a23 23 0 0 0 46 0c0-.335-.011-.668-.025-1z"/>
                            <ellipse class="cls-4" cx="33" cy="23" rx="3" ry="4"/>
                            <ellipse class="cls-5" cx="33" cy="23" rx="2" ry="3"/>
                            <circle class="cls-6" cx="34" cy="22" r="1"/>
                            <ellipse class="cls-4" cx="15" cy="23" rx="3" ry="4"/>
                            <ellipse class="cls-5" cx="15" cy="23" rx="2" ry="3"/>
                            <circle class="cls-6" cx="16" cy="22" r="1"/>
                            <path class="cls-5" d="M10 19v-2c3.722 0 6-1.295 6-2h2c0 2.626-4.024 4-8 4zM38 19c-3.976 0-8-1.374-8-4h2c0 .705 2.278 2 6 2z"/>
                            <path class="cls-4" d="M24 35h-5.5a5.265 5.265 0 0 1 5.5-5 5.265 5.265 0 0 1 5.5 5z"/>
                            <path class="cls-5" d="M24 31a5.4 5.4 0 0 1 5.39 4h.11a5.265 5.265 0 0 0-5.5-5 5.265 5.265 0 0 0-5.5 5h.11A5.4 5.4 0 0 1 24 31z"/>
                            <path d="M47 12a4 4 0 0 1-8 0c0-2.209 3-8 4-8s4 5.791 4 8z" style="fill:#3bc5f6"/>
                            <path d="M43 4c-1 0-4 5.791-4 8a4 4 0 0 0 8 0c0-2.209-3-8-4-8zm0 8.5a2.848 2.848 0 0 1-3-2.667C40 8.361 42.25 4.5 43 4.5s3 3.861 3 5.333a2.848 2.848 0 0 1-3 2.667z" style="fill:#00a3e1"/>
                            <path class="cls-3" d="M43 16a3.991 3.991 0 0 1-3.861-3.008A4.661 4.661 0 0 0 39 14a4 4 0 0 0 6.846 2.807q-.255-.777-.562-1.529A3.982 3.982 0 0 1 43 16z"/>
                            <ellipse class="cls-6" cx="44" cy="11" rx=".825" ry="1.148" transform="rotate(-45.02 44 11)"/>
                            <ellipse class="cls-6" cx="44.746" cy="9.5" rx=".413" ry=".574" transform="rotate(-45.02 44.746 9.5)"/>
                            <ellipse class="cls-6" cx="36" cy="9" rx=".825" ry="1.148" transform="rotate(-45.02 36 9)"/>
                            <ellipse class="cls-6" cx="29.746" cy="4.5" rx=".413" ry=".574" transform="rotate(-45.02 29.746 4.5)"/>
                            <ellipse class="cls-6" cx="33" cy="7" rx="1.65" ry="2.297" transform="rotate(-45.02 33 7)"/>
                        </g>
                    </svg>
                </div>
            `,
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'Cancel',
      reverseButtons: true,
      customClass: {
        title: 'fs-6',
        cancelButton: 'btn btn-sm btn-secondary',
        confirmButton: 'btn btn-sm btn-danger',
        htmlContainer: 'text-left'
      },
      allowOutsideClick: false,
      allowEscapeKey: false,
    }).then((result) => {
      if (result.isConfirmed) {
        axios.delete(`${baseURL}/product-categories/${id}`)
          .then(() => {
            toast.success(`${name} has been deleted.`, {
              position: "top-center",
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "light",
            });

            // Refresh categories list or do a soft reload
            if (typeof fetchCategories === 'function') {
              fetchCategories();
            } else {
              softRefresh(); // your fallback
            }
          })
          .catch((error) => {
            console.error("Delete failed:", error);
            toast.error("Something went wrong while deleting.", {
              position: "top-center",
              autoClose: 4000,
              theme: "colored",
            });
          });
      } else {
        toast.info(`Deletion cancelled. ${name} was not deleted.`, {
          position: "top-center",
          autoClose: 3000,
          theme: "light",
        });
      }
    });
  };

  const [file, setFile] = React.useState(null)
  const fileHandler = (e) => {
    setFile(e.target.files[0]);
    setTimeout(function () {
      document.getElementById("imagePreview").getAttribute("src");
      //addFormData.image = src; 
    }, 200);
  }

  function RemoveImage() {
    return (
      setFile()
    )
  }

  const handleStatusChange = (productCategoryId, currentStatus) => {
    const newStatus = currentStatus === 0 ? 1 : 0;

    axios.put(`${baseURL}/product-categories/status/${productCategoryId}`, { status: newStatus })
      .then(() => {
        fetchCategories();
      })
      .catch(error => {
        console.error("Error updating status:", error);
      });
  };

  useEffect(() => {
    const $table = $(tableRef.current);

    // 🧹 Destroy existing DataTable instance if it exists
    if ($.fn.dataTable.isDataTable(tableRef.current)) {
      $table.DataTable().clear().destroy();
    }

    if (productCategories.length > 0) {
      $table.DataTable({
        responsive: true,
        ordering: false,
        // language: {
        //             "lengthMenu": "Show&nbsp;&nbsp; _MENU_",
        //         },
        "language": {
          "lengthMenu": "Show _MENU_",
        },
        dom:
          "<'row'" +
          "<'col-sm-6 d-flex align-items-center justify-content-start mb-2'l>" +
          "<'col-sm-6 d-flex align-items-center justify-content-end mb-2'f>" +
          ">" +
          "<'table-responsive'tr>" +
          "<'row'" +
          "<'col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start mt-2'i>" +
          "<'col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end mt-2'p>" +
          ">"
      });
    }

    // 🔚 Clean up on unmount
    return () => {
      if ($.fn.dataTable.isDataTable(tableRef.current)) {
        $table.DataTable().destroy();
      }
    };
  }, [productCategories]);

  const handleAddSuccess = () => {
    console.log("Add success called!");
    toast.success("Product category added successfully!");
    setOpen(false);
    softRefresh();
  };

  const [selectedCategory, setSelectedCategory] = useState(null);

  const handleViewModal = (category) => {
    setSelectedCategory(category); // store the selected item
    setModalType("ViewProductCatModal");
    setOpen(true);
  };

  const handleModalToggleCreate = (category) => {
    setSelectedCategory(category);  // Store selected category
    setModalType("CreateProduct");
    setOpen(true);
  };

  return (
    <>
      <div className="d-flex align-items-center justify-content-between page-titles px-0 py-1 mx-0 flex-wrap">
        <div className="mb-2">
          <div className="mb-0 px-0">
            <h4 style={{ color: '#025d3a' }}>Manage Products</h4>
          </div>
          <ol className="breadcrumb fs-7">
            <li className="breadcrumb-item">
              <Link to="/dashboard">Dashboard</Link>
            </li>
            <li className="breadcrumb-item">
              <i className="fa-solid fa-angles-right fs-8"></i>
            </li>
            <li className="breadcrumb-item active">Package Management</li>
          </ol>
        </div>

        {open && modalType === "Add" && (
          <Add show={open} onClose={() => setOpen(false)} onSuccess={handleAddSuccess} refresh={fetchCategories} />
        )}

        {open && modalType === "Edit" && (
          <Edit show={open} onClose={() => setOpen(false)} refresh={fetchCategories} />
        )}

        {open && modalType === "ViewProductCatModal" && (
          <ViewProdCat show={open} onClose={() => setOpen(false)} />
        )}

        {/* {open && modalType === "CreateProduct" && (
                    <AddProduct show={open} onClose={() => setOpen(false)} />
                )} */}

        {open && modalType === "CreateProduct" && (
          <AddProduct
            show={open}
            onClose={() => setOpen(false)}
            defaultCategory={selectedCategory} // <- pass here 
            refresh={fetchCategories}
          />
        )}

      </div>

      <Col xl={12} className="mb-3">
        <div className="custom-tab-1">
          <Tab.Container activeKey={key} onSelect={(k) => setKey(k)}>
            <Nav as="ul" className="nav-tabs mb-4">

              <Nav.Item as="li">
                <Nav.Link >
                  <Link to="/manage-products" className="d-flex align-items-center text-decoration-none">
                    <i className="fa fa-shopping-basket me-3" />
                    <label className="fs-6">Products</label>
                    <Badge
                      as="a"
                      href=""
                      bg=" badge-circle"
                      className="badge-outline-info ms-2 fw-bold fs-8"
                    >
                      {String(manageProductCount).padStart(2, "0")}
                    </Badge>
                  </Link>
                </Nav.Link>
              </Nav.Item>

              <Nav.Item as="li">
                <Nav.Link eventKey="product_category">
                  <Link to="/product-category" className="d-flex align-items-center text-decoration-none">
                    <i className="fa-solid fa-list me-3" />
                    <label className="fs-6">Product Category</label>
                    <Badge
                      as="a"
                      href=""
                      bg=" badge-circle"
                      className="badge-outline-info ms-2 fw-bold fs-8"
                    >
                      {String(categoryCount).padStart(2, "0")}
                    </Badge>
                  </Link>
                </Nav.Link>
              </Nav.Item>

            </Nav>

            <Tab.Content className="pt-4">
              <Tab.Pane eventKey="product_category">
                <Row>
                  <Col
                    xl={12}
                    className="mb-3 d-flex align-items-end justify-content-end gap-3"
                  >
                    <Link
                      to={"#"}
                      onClick={handleModalToggle}
                      className="btn btn-primary float-end btn-sm mb-2"
                    >
                      <span className="me-2">
                        <i className="fa-solid fa-plus fs-8"></i>
                      </span>
                      <span>Add Product Category</span>
                    </Link>
                  </Col>

                  <Col xl={12}>
                    <div className="table-container">

                      <div className="d-flex justify-content-between align-items-center mb-3">
                        {/* Left: Show entries dropdown */}
                        <div>
                          <label className="me-2">Show</label>
                          <select
                            className="form-select d-inline w-auto"
                            style={{ fontSize: '0.85rem', height: '30px' }}
                            value={perPage}
                            onChange={(e) => {
                              setPerPage(Number(e.target.value));
                              setPage(1); // Reset to first page
                            }}
                          >

                            <option value={25}>25</option>
                            <option value={50}>50</option>
                            <option value={100}>100</option>
                            <option value={125}>125</option>
                          </select>
                        </div>

                        {/* Right: Search input */}
                        <div>
                          <input
                            type="text"
                            style={{ fontSize: '0.85rem', height: '40px' }}
                            placeholder="Search by category or schedule..."
                            className="form-control"
                            value={searchTerm}
                            onChange={(e) => {
                              const onlyLetters = e.target.value.replace(/[^a-zA-Z\s]/g, '');
                              setSearchTerm(onlyLetters);
                              setPage(1);
                            }}
                          // onChange={(e) => {
                          //     setSearchTerm(e.target.value);
                          //     setPage(1); // Reset page on new search
                          // }}
                          />
                        </div>
                      </div>

                      <table
                        // ref={tableRef}
                        id="kt_datatable_responsive_approved"
                        className="table align-middle table-row-dashed table-striped table-hover fs-7 gy-1 gs-2 dataTable"
                        style={{ borderBottom: '2px solid #ddd', overflowX: 'scroll' }}
                      >
                        <thead>
                          <tr className="text-start text-muted fw-bold fs-6 gs-0 th_head">
                            {/* <th className="min-w-50px text-start">S.No</th> */}
                            <th className="min-w-150px">Product Category</th>
                            <th className="min-w-100px">schedule</th>
                            <th className='min-w-100px text-center'>Product Count</th>
                            <th className="min-w-300px">Description</th>
                            <th className="min-w-100px">Status</th>
                            <th className="min-w-100px">Actions</th>
                          </tr>
                        </thead>

                        <tbody className="text-gray-600 fw-semibold fs-7">

                          {Array.isArray(productCategories) && productCategories.length > 0 ? (
                            productCategories.map((productcategories, idx) => (
                              <tr key={productcategories.sno}>
                                {/* <td className="text-start">
                                <label className="text-black font-w400 fs-7">
                                  {idx + 1}
                                </label>
                              </td> */}
                                <td>
                                  <div className="d-flex align-items-center justify-content-start gap-2">
                                    <LightGallery
                                      onInit={onInit}
                                      speed={500}
                                      plugins={[lgThumbnail, lgZoom]}
                                    >
                                      <div
                                        data-src={
                                          productcategories.productcategory_img ||
                                          default_img
                                        }
                                        className="border rounded px-1 py-0"
                                      >
                                        <img
                                          src={
                                            productcategories.productcategory_img ||
                                            default_img
                                          }
                                          alt="Category"
                                          className="cursor-pointer w-45px h-45px"
                                        />
                                      </div>
                                    </LightGallery>

                                    <div className="d-block">
                                      <OverlayTrigger
                                        placement="top"
                                        overlay={
                                          <Tooltip id="tooltip">
                                            {productcategories.productcategory_name}
                                          </Tooltip>
                                        }
                                      >
                                        <label className="text-truncate mw-150px text-black font-w400 fs-7">
                                          {productcategories.productcategory_name}
                                        </label>
                                      </OverlayTrigger>
                                    </div>
                                  </div>
                                </td>
                                <td>
                                  <label className="text-black font-w400 fs-7">
                                    {productcategories.schedule_name}
                                  </label>
                                </td>
                                <td className='text-center'>
                                  <Badge bg="success" className='text-white fs-7 py-0 px-2'>{productcategories.product_count}</Badge>
                                </td>
                                <td>
                                  <OverlayTrigger
                                    trigger={['hover', 'focus']}
                                    placement="bottom"
                                    overlay={
                                      <Tooltip className="toltip-popover">
                                        <span className="fs-8 text-white fw-semibold">
                                          {productcategories.description
                                            ? productcategories.description
                                            : "No description available."}
                                        </span>
                                      </Tooltip>
                                    }
                                  >
                                    <div className="text-truncate mw-400px text-black font-w400 fs-7">
                                      {productcategories.description
                                        ? productcategories.description
                                        : "No description available."}
                                    </div>
                                  </OverlayTrigger>
                                </td>
                                <td>
                                  <div className="form-check form-switch d-flex align-items-center mb-3">
                                    <input
                                      className="form-check-input me-2"
                                      type="checkbox"
                                      role="switch"
                                      checked={productcategories.status == 0}
                                      onChange={() =>
                                        handleStatusChange(
                                          productcategories.sno,
                                          productcategories.status
                                        )
                                      }
                                    />
                                  </div>
                                </td>
                                <td>
                                  {/* <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className='toltip-popover' ><span className='fs-8 text-white fw-semibold'>View</span></Tooltip>} >
                                      <Button variant="primary tp-btn-light px-2 py-1 me-1" 
                                      onClick={() => handleViewModal(productcategories)} 
                                      // onClick={handleViewModal}
                                      >
                                          <span><i class="fa-solid fa-eye fs-6 mt-1"></i></span>
                                      </Button>
                                  </OverlayTrigger> */}
                                  <span className="text-end">
                                    <OverlayTrigger
                                      trigger={['hover', 'focus']}
                                      placement="bottom"
                                      overlay={
                                        <Tooltip className="toltip-popover">
                                          <span className="fs-8 text-white fw-semibold">
                                            Edit
                                          </span>
                                        </Tooltip>
                                      }
                                    >
                                      <Button
                                        variant="primary tp-btn-light px-2 py-1 me-1"
                                        onClick={() =>
                                          handleModalDepartment_Edit(
                                            productcategories.sno
                                          )
                                        }
                                      >
                                        <i className="fa-solid fa-pen-to-square fs-6"></i>
                                      </Button>
                                    </OverlayTrigger>

                                    {/* <OverlayTrigger
                                    trigger={['hover', 'focus']}
                                    placement="bottom"
                                    overlay={
                                      <Tooltip className="toltip-popover">
                                        <span className="fs-8 text-white fw-semibold">
                                          Delete
                                        </span>
                                      </Tooltip>
                                    }
                                  >
                                    <Button
                                      variant="primary tp-btn-light px-2 py-1 me-1"
                                      onClick={() =>
                                        DeleteModal(
                                          productcategories.sno,
                                          productcategories.productcategory_name,
                                          fetchCategories
                                        )
                                      }
                                    >
                                      <i className="fa-solid fa-trash-can fs-6 mt-1"></i>
                                    </Button>
                                  </OverlayTrigger> */}

                                    <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className='toltip-popover' ><span className='fs-8 text-white fw-semibold'>Add Product</span></Tooltip>} >
                                      <Button variant="primary tp-btn-light px-2 py-1 me-1"
                                        // onClick={handleModalToggleCreate}
                                        onClick={() => handleModalToggleCreate(productcategories)}
                                      >
                                        <span><i class="fa-solid fa-shopping-basket fs-6 mt-1"></i></span>
                                      </Button>
                                    </OverlayTrigger>
                                  </span>
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="7" className="text-center text-muted py-4">
                                No product categories found.
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>

                      <div className="d-flex justify-content-between align-items-center mt-3">
                        {/* Bottom left: Showing x to y of z entries */}
                        <div>
                          {productCategories.length > 0 && (
                            <span className="text-muted">
                              Showing {(page - 1) * perPage + 1} to {(page - 1) * perPage + productCategories.length} of {totalPages * perPage - (perPage - productCategories.length)} entries
                            </span>
                          )}
                        </div>

                        {/* Bottom right: Pagination */}
                        <nav>
                          <ul className="pagination mb-0" style={{ fontSize: '0.75rem' }}>
                            <li className={`page-item ${page === 1 ? 'disabled' : ''}`}>
                              <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(page - 1)}>Previous</button>
                            </li>
                            {[...Array(totalPages)].map((_, i) => (
                              <li key={i} className={`page-item ${page === i + 1 ? 'active' : ''}`}>
                                <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(i + 1)}>{i + 1}</button>
                              </li>
                            ))}
                            <li className={`page-item ${page === totalPages ? 'disabled' : ''}`}>
                              <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(page + 1)}>Next</button>
                            </li>
                          </ul>
                        </nav>

                      </div>

                      <EditProdcat
                        show={editModalShow}
                        onClose={() => setEditModalShow(false)}
                        id={currentItemId}
                        onUpdated={fetchCategories}
                      />

                      {open && modalType === "ViewProductCatModal" && (
                        <ViewProdCat
                          show={open}
                          data={selectedCategory} // pass category data
                          onClose={() => setOpen(false)}
                        />
                      )}

                    </div>
                  </Col>
                </Row>
              </Tab.Pane>
            </Tab.Content>
          </Tab.Container>
        </div>
      </Col>
    </>
  );

}
export default ProductCategory;